const messages = {
  "ui.inlineInput.unknown": "Unknown",
} as const;

export default messages;
